import React from 'react';
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

export const OfflineIndicator: React.FC = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div 
      role="status"
      aria-live="polite"
      className="fixed bottom-4 left-4 z-50 flex items-center gap-2 rounded-xl bg-amber-600/95 border border-amber-400/40 px-3.5 py-2 text-xs font-semibold text-white shadow-[0_4px_20px_rgba(217,119,6,0.4)] backdrop-blur-md animate-fade-in"
    >
      <WifiOff size={15} className="animate-pulse text-amber-200" />
      <span>Modo Offline &mdash; Você está lendo a versão em cache.</span>
    </div>
  );
};
